<template>
  <section class="group">
    <div class="group-header" role="heading" aria-level="4">
      <h4 class="group-title">
        {{ title }}
      </h4>
    </div>

    <ul class="list">
      <TaskItem
        v-for="(item, i) in items"
        :key="i"
        :text="item.title"
        :substep-index="item.substepIndex"
        :steps-time="stepsTime"
        :substep-metrics="substepMetrics"
        :is-optional="optionalSteps.includes(item.substepIndex)"
        :is-negative="negativeSteps.includes(item.substepIndex)"
        :is-low-confidence="lowConfidenceSteps.includes(item.substepIndex)"
      />
    </ul>
  </section>
</template>

<script>
import TaskItem from './TaskItem.vue';

export default {
  name: 'TaskGroup',
  components: { TaskItem },
  props: {
    title: { type: String, default: '' },
    items: { type: Array, default: () => [] },
    stepsTime: { type: Object, default: () => ({}) },
    substepMetrics: { type: Object, default: () => ({}) },
    optionalSteps: { type: Array, default: () => [] },
    negativeSteps: { type: Array, default: () => [] },
    lowConfidenceSteps: { type: Array, default: () => [] },
  },
};
</script>

<style scoped>
.group + .group {
  margin-top: 10px;
}

.group-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #f5f7fa;
  cursor: default;
}

.group-title {
  font-weight: 700;
  font-size: var(--fs-md);
  color: #111827;
  line-height: 1.2;
  text-align: left;
  margin: 0;
}

.list {
  margin: 3px 0 0 0;
  padding: 0 0 0 0.5em;
  list-style: none;
  display: grid;
  gap: 6px;
}
</style>
